import React, { useEffect, useState } from 'react';
import { Button, Label } from 'reactstrap';
import KTable from '../../components/KTable';
import KPagination from '../../components/KPagination';
import {
  ApplyReimbursementDataType,
  ColumnHeaderType,
  LoggedUserType,
  PaginationType,
  ReimbursementFilterType,
} from '../../utils/Types';
import CenterSpinner from '../../components/CenterSpinner';
import {
  API_STATUS,
  APPLY_REIMBURSEMENT_TYPES,
  DEFAULT_OPTION,
  DEFAULT_PAGE_SIZE,
} from '../../utils/Constant';
import { ApplyReimbursementColumnHeader } from './ReimbursementHelper';
import { useAppDispatch, useAppSelector } from '../../store/redux-hooks';
import {
  getApplyReimbursementData,
  reimbursementSelector,
} from '../../features/reimbursementSlice';
import ReimbursementFilter from '../../filters/ReimbursementFilter';
import ApplyReimbursementModal, {
  MODAL_TYPE,
} from '../modals/ApplyReimbursementModal';
import { loginSelector } from '../../features/loginSlice';

const ApplyReimbursementPage: React.FunctionComponent = () => {
  const [showLoader, setShowLoader] = useState<boolean>(false);
  const [pageSize, setPageSize] = useState<number>(DEFAULT_PAGE_SIZE);
  const [isModalOpen, setIsModalOpen] = useState<boolean>(false);
  const [selectedTask, setSelectedTask] = useState<any>(null);
  const [claimTypeMode, setClaimTypeMode] = useState<string | null>(null);
  const [selectedFilter, setSelectedFilter] = useState<ReimbursementFilterType>(
    {
      taskId: '',
      taskName: DEFAULT_OPTION,
      zone: DEFAULT_OPTION,
      state: DEFAULT_OPTION,
      district: DEFAULT_OPTION,
      city: DEFAULT_OPTION,
    }
  );
  const dispatch = useAppDispatch();
  const [currentPage, setCurrentPage] = useState<number>(1);
  const applyReimbursementData: ApplyReimbursementDataType[] = useAppSelector(
    reimbursementSelector
  ).applyReimbursementData;
  const pagination: PaginationType = useAppSelector(
    reimbursementSelector
  ).applyReimbursementPagination;
  const apiStatus = useAppSelector(reimbursementSelector).apiProgressStatus;
  const user: LoggedUserType = useAppSelector(loginSelector).user;

  const toggleModal = () => {
    setIsModalOpen(!isModalOpen);
  };

  const onTableAction = (param: any, columnHeader: ColumnHeaderType) => {
    setSelectedTask(param);
    setClaimTypeMode(APPLY_REIMBURSEMENT_TYPES.ALREADY_EXISTED_TASK);
    toggleModal();
  };

  const getApplyReimbursementDataList = (filter: ReimbursementFilterType) => {
    const data: any = {
      status: 13, //13 for the completed tasks
      pageNumber: currentPage,
      pagePerCount: pageSize,
      assignedToId: user?.candidateId || null,
    };
    if (filter) {
      if (filter?.taskName?.value) {
        data.taskName = filter.taskName?.value;
      }
      if (filter.taskId) {
        data.taskId = filter.taskId;
      }
    }
    dispatch(getApplyReimbursementData(data));
  };

  useEffect(() => {
    if (apiStatus && apiStatus === API_STATUS.LOADING) {
      setShowLoader(true);
    } else {
      setShowLoader(false);
    }
  }, [apiStatus]);

  useEffect(() => {
    getApplyReimbursementDataList(selectedFilter);
  }, [pageSize, currentPage]);

  return (
    <div>
      <div className="d-flex justify-content-between align-items-center mb-2">
        <Label className="text-heading">Apply Reimbursement</Label>
        <Button
          variant="primary"
          className="me-2 cl-btn-primary"
          onClick={() => {
            setClaimTypeMode(APPLY_REIMBURSEMENT_TYPES?.NEW_TASK);
            toggleModal();
          }}
        >
          Raise Claim
        </Button>
      </div>

      <ReimbursementFilter
        onApplyFilters={(filter: ReimbursementFilterType) => {
          getApplyReimbursementDataList(filter);
          setSelectedFilter(filter);
          setCurrentPage(1);
        }}
        showLocationFilter={false}
      />
      <div className="mt-4">
        <KTable
          data={applyReimbursementData}
          tableParentClass="table-parent-assign-grid"
          columnHeader={ApplyReimbursementColumnHeader}
          isLoading={showLoader}
          onAction={(param: any, columnHeader: ColumnHeaderType) => {
            onTableAction(param, columnHeader);
          }}
        />
        {applyReimbursementData && applyReimbursementData.length > 0 && (
          <KPagination
            totalPages={pagination?.totalPages}
            currentPage={pagination?.currentPage}
            pageSize={pagination?.pageSize}
            onPageChange={setCurrentPage}
            onSizeChange={setPageSize}
            fromItem={pagination.fromItem}
            toItem={pagination.toItem}
            totalItems={pagination?.totalItems}
          />
        )}
      </div>
      {isModalOpen && (
        <ApplyReimbursementModal
          isOpen={isModalOpen}
          toggleModal={toggleModal}
          modalType={MODAL_TYPE.apply}
          selectedTask={selectedTask}
          claimTypeMode={claimTypeMode}
        />
      )}
      <CenterSpinner showLoader={showLoader} className="spinner-60" />
    </div>
  );
};

export default ApplyReimbursementPage;
